import { getI18nFormattedMessage } from '../../../utils/intl';

export const PORTAL_TYPE = '0';
export const IDP_TYPE = '1';
export const SINGLE_ORG_TYPE = '0';
export const MULTIPLE_ORG_TYPE = '1';
export const SAML_OLD = 'SAMLOld';
export const SAML = 'SAML';
export const LDAP = 'LDAP';
export const JWT = 'JWT';
export const DEFAULT = 'default';

export const AUTH_SETTINGS_LDAP_DETAILS_HELP = {
    title: getI18nFormattedMessage('label.help'),
    descriptions: '',
    subItems: [
      {
        id: 0,
        title: '',
        descriptions: 'This scheme can be used to map IDP users  to a single organization.  Alternatively portal can be used to authorize users and provide them with roles. ',
      },
      {
        id: 1,
        title: '',
        descriptions: 'To map users to multiple organizations use the non-deprecated SAML provider.',
      },
      {
        id: 2,
        title: '',
        descriptions: 'Note that if an icon is not uploaded a default icon will be used.',
      },
    ],
  };
  
export const AUTH_SETTINGS_LDAP_ATTRIBUTE_MAPPING_HELP = {
  title: getI18nFormattedMessage('label.help'),
  descriptions: 'Manage user roles through portal ( in Users section) or map portal’s roles directly through the attributes and their values from the IDP.',
  subItems: [
    {
      id: 0,
      title: 'User Types',
      descriptions: '',
      list: {
        items: [
          'Global Users: not restricted by organization bounds by default (see API Owners below).',
          'Org Users: restricted by their assigned organization(s). They can have different roles in different organizations.',
        ],
      },
    },
    {
      id: 1,
      title: 'Global User',
      descriptions: '',
      list: {
        items: [
          'Admin: Full control of all aspects of portal',
          'API Owner: Controls all APIs across all organizations, conversely can be assigned to specific APIs to control. Can see all organizations and users.',
        ],
      },
    },
    {
      id: 2,
      title: 'Org User Roles',
      descriptions: '',
      list: {
        items: [
          'Org Publisher: Controls all APIs inside their assigned organization.',
          'Org Admin: Controls users in an organization.',
          'Developer: Has access to the API details and spec and can control applications and the default API key.',
        ],
      },
    },
  ],
};

export const AUTH_SETTINGS_LDAP_AUTH_TYPE_DATA = [
  {
    id: '0',
    name: getI18nFormattedMessage('label.auth.portal'),
    description: getI18nFormattedMessage('label.auth.portal.help.text'),
  },
  {
    id: '1',
    name: getI18nFormattedMessage('label.auth.external.identify.provider'),
    description: getI18nFormattedMessage('label.auth.external.identify.provider.help.text'),
  },
];

export const AUTH_SETTINGS_SAML_ROLE_TYPE_DATA = [
  {
    id: '0',
    name: getI18nFormattedMessage('label.auth.single.organization'),
    description: getI18nFormattedMessage('label.auth.single.organization.help.text'),
  },
  {
    id: '1',
    name: getI18nFormattedMessage('label.auth.multiple.organization'),
    description: getI18nFormattedMessage('label.auth.multiple.organization.help.text'),
  },
];

export const SAML_BINDINGS = [
  {
    uuid: 'post',
    name: getI18nFormattedMessage('label.post'),
  },
  {
    uuid: 'redirect',
    name: getI18nFormattedMessage('label.redirect'),
  },
];

export const SAML_TOKEN_ATTRIBUTES = [
  {
    uuid: 'parameter',
    name: getI18nFormattedMessage('label.parameter'),
  },
  {
    uuid: 'cookie',
    name: getI18nFormattedMessage('label.cookie'),
  },
  {
    uuid: 'header',
    name: getI18nFormattedMessage('label.header'),
  },
];

export const SAML_MISMATCH_DATA = [
  {
    uuid: 'FAIL',
    name: getI18nFormattedMessage('label.fail'),
  },
  {
    uuid: 'AssignGuestRole',
    name: getI18nFormattedMessage('label.auth.assign.guest.role'),
  },
]

